import { lazy } from "react";
import Loadable from "app/components/Loadable";

const MenuManager = Loadable(lazy(() => import("./MenuManager")));

const MenuManagerRoutes = [{ path: "/menu/manager", element: <MenuManager /> }];

export default MenuManagerRoutes;
